import React, { useEffect } from 'react'
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    HStack,
    Box,
    Text,
    Spacer,
    Stack,
    Flex,
    Image,

} from '@chakra-ui/react'
import SraList from './SraList'
import moment from 'moment/moment'
import { GrAttachment } from 'react-icons/gr'
import { BsArrowDownCircleFill, BsArrowUpCircleFill, BsFillCloudUploadFill } from 'react-icons/bs'
import Input from './Input'
import { useState } from 'react'
import Button from './Button'
import { UploadInvoice, UploadWaybillFile } from '../Utils/ApiCalls'
import { local } from '../Utils/ApiConfig'



export default function MoreSRA({ isOpen, setupdateImage, onClose, singleData }) {

    console.log("singleData", singleData)


    const [Loading, setLoading] = useState(false);
    const [Image, setImage] = useState(null);
    const [WayBill, setWayBill] = useState(false);
    const [invoice, setinvoice] = useState(false);

    const [errorMsg, setErrorMsg] = useState({
        status: false,
        msg: ""
    });

    const [SuccessMsg, setSuccessMsg] = useState({
        status: false,
        msg: "sdfgvhbnm"
    });

    const handleWaybill = (e) => {

        let file = e.target.files[0]
        setImage(file)
        setWayBill(true)
        setinvoice(false)


    }
    const handleInvoice = (e) => {

        let file = e.target.files[0]
        setImage(file)
        setinvoice(true)
        setWayBill(false)


    }

    const uploadInvoice = async () => {

        const formData = new FormData();

        formData.append("file", Image);


        console.log("formData", formData.get("file"))

        try {


            setLoading(true)

            let result = await UploadInvoice(formData, singleData[0]?._id);

            console.log("resultWaybill", result);

            if (result.status == true) {
                setLoading(false)
                setSuccessMsg({
                    status: true,
                    msg: "IIR Uploaded successfully"
                })

                setImage(null)

               setupdateImage(true)

                setTimeout(() => {
                    setSuccessMsg({
                        status: false,
                        msg: ""
                    })
                }, 3000);


            } else {
                setLoading(false)
                setErrorMsg({
                    status: true,
                    msg: result.msg
                })
                setTimeout(() => {
                    setErrorMsg({
                        status: false,

                    })
                }, 3000);

            }


        } catch (e) {

            setLoading(false)
            console.error('Error:', e.message);
        }

    }
    const uploadWaybill = async () => {

        const formData = new FormData();

        formData.append("file", Image);


        console.log("formData", formData.get("file"))

        try {


            setLoading(true)

            let result = await UploadWaybillFile(formData, singleData[0]?._id);

            console.log("resultWaybill", result);

            if (result.status == true) {
                setLoading(false)
                setSuccessMsg({
                    status: true,
                    msg: "Waybill Uploaded successfully"
                })

                setImage(null)
                setupdateImage(true)


                setTimeout(() => {
                    setSuccessMsg({
                        status: false,
                        msg: ""
                    })
                }, 3000);


            } else if(result.status == false) {
                setLoading(false)
                setErrorMsg({
                    status: true,
                    msg: result.msg
                })
                setTimeout(() => {
                    setErrorMsg({
                        status: false,

                    })
                }, 3000);

            } else {
                alert(result)
            }


        } catch (e) {

            setLoading(false)
            setErrorMsg({
                status: true,
                msg: e.message
            })
            console.error('Error:', e.message);
        }

    }
    const [OpenImg, setOpenImg] = useState(false);

    const toggle = () => {
        setOpenImg(!OpenImg)
    }

    useEffect(() => {
        setOpenImg(false)
    }, [isOpen]);

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered scrollBehavior={"inside"} size={"xl"}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>SRA Details</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Stack spacing={"20px"}>
                        <HStack>
                            <SraList title={"suppliers id: "} details={singleData[0]?.suppliersname} />
                            <Spacer />
                            <SraList title={"posted on stock card: "} details={singleData[0]?.postedonstockcard} />
                        </HStack>
                        <HStack>
                            <SraList title={"cost center: "} details={singleData[0]?.costcenter} />
                            <Spacer />
                            <SraList title={"custom duty: "} details={singleData[0]?.customduty} />
                        </HStack>
                        <HStack>
                            <SraList title={"date received: "} details={moment(singleData[0]?.datereceived).format('DD/MM/YYYY')} />
                            <Spacer />
                            <SraList title={"invoice number: "} details={singleData[0]?.invoicenumber} />
                        </HStack>
                        <HStack>
                            <SraList title={"invoice value: "} details={singleData[0]?.invoicevalue} />
                            <Spacer />
                            <SraList title={"IIR numbers: "} details={singleData[0]?.itemnos} />
                        </HStack>
                        <HStack>
                            <SraList title={"inward freight: "} details={singleData[0]?.inwardsfreight} />
                            <Spacer />
                            <SraList title={"total: "} details={singleData[0]?.total} />
                        </HStack>
                        <SraList title={"raised: "} details={singleData[0]?.raised} />

                        <SraList title={"received: "} details={singleData[0]?.received} />

                        <Text fontWeight={"800"}>Product</Text>

                        {
                            singleData[0]?.product.map((item, i) => (
                                <Stack spacing={"18px"} borderTop={"1px solid grey"} pt="10px">
                                    <HStack>
                                        <SraList title={"quantity inspected: "} details={item.qtyinspected} />
                                        <Spacer />
                                        <SraList title={"shelf id: "} details={item.shelfid.productshelfid} />
                                    </HStack>
                                    <HStack>
                                        <SraList title={"price: "} details={item.status} />
                                        <Spacer />
                                        <SraList title={"value: "} details={item.value} />
                                    </HStack>
                                    <HStack>
                                        <SraList title={"SRA: "} details={item.sra} />
                                        <Spacer />
                                        <SraList title={"status: "} details={item.status} />
                                    </HStack>

                                </Stack>
                            ))
                        }

                        <HStack borderBottom={"1px solid grey"} pb="10px">
                            <Text fontWeight={"800"}>Attachment</Text>
                            <Box onClick={toggle} fontSize="18px" color="teal">
                                {
                                    OpenImg ? <BsArrowDownCircleFill /> : <BsArrowUpCircleFill />
                                }
                            </Box>


                        </HStack>

                        <Flex justifyContent={"space-between"}>


                            {
                                OpenImg === true && (
                                    <Box>

                                        <Text textAlign="left" fontWeight={"500"}>Waybill Image</Text>
                                        {
                                            singleData[0]?.waybillimageurl  ? (
                                                <Box display={"flex"} justifyContent="center">


                                                    <br />
                                                    <a target={"blank"} href={`${local}/api/v1/uploads/${singleData[0]?.waybillimageurl}`}>

                                                        <img class="img" src={`${local}/api/v1/uploads/${singleData[0]?.waybillimageurl}`} alt="waybill" />
                                                    </a>
                                                </Box>
                                            ) : (
                                                <Text textAlign="left" fontWeight={"500"}>Not found</Text>

                                            )
                                        }


                                    </Box>
                                )
                            }


                            {
                                OpenImg === true && (
                                    <Box >

                                        <Text textAlign="left" fontWeight={"500"}>IIR Image</Text>
                                        {
                                            singleData[0]?.invoiceimageurl  ? (
                                                <Box display={"flex"} justifyContent="center">                                            <br />
                                                    <a target={"blank"} href={`${local}/api/v1/uploads/${singleData[0]?.invoiceimageurl}`}>

                                                        <img class="img" src={`${local}/api/v1/uploads/${singleData[0]?.invoiceimageurl}`} alt="waybill" />
                                                    </a>

                                                </Box>
                                            ) : (
                                                <Text textAlign="left" fontWeight={"500"}>Not found</Text>

                                            )
                                        }


                                    </Box>
                                )
                            }



                        </Flex>






                    </Stack>

                    <Input onChange={handleWaybill} type="file" id="upload-waybill" hidden />
                    <Input onChange={handleInvoice} type="file" id="upload-invoice" hidden />




                    <Box pos={"sticky"} bottom="0" bgColor="#fff" py="10px">
                        <Flex justifyContent={"space-between"} flexWrap="wrap" mt="20px" cursor={"pointer"} >


                            <label className='hover' for="upload-waybill">
                                <HStack bg="teal" px="15px" py="10px" color={"#fff"} rounded="8px">
                                    <Box color={"#fff"}><BsFillCloudUploadFill /></Box> <Text>Upload waybill</Text>
                                </HStack>
                            </label>

                            <label className='hover' for="upload-invoice">
                                <HStack bg="teal" px="15px" py="10px" color={"#fff"} rounded="8px">
                                    <Box color={"#fff"}><BsFillCloudUploadFill /></Box> <Text>Upload IIR</Text>
                                </HStack>
                            </label>

                        </Flex>

                        {
                            Image !== null && (
                                <HStack mt="10px">
                                    <Text color={"green"}>{Image.name}</Text>

                                    {
                                        WayBill && (

                                            <Button onClick={uploadWaybill} isLoading={Loading} background='green'>Upload this file </Button>

                                        )
                                    }

                                    {
                                        invoice && (

                                            <Button onClick={uploadInvoice} isLoading={Loading} background='green'>Upload this file </Button>

                                        )
                                    }
                                </HStack>
                            )
                        }


                        {
                            errorMsg.status && (
                                <Text mt={"10px"} color="red.200" textAlign="center">{errorMsg.msg}</Text>
                            )
                        }

                        {
                            SuccessMsg.status && (
                                <Text mt={"10px"} color="green" textAlign="center">{SuccessMsg.msg}</Text>
                            )
                        }

                    </Box>


                </ModalBody>

                <ModalFooter>


                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}
